module.exports = __webpack_public_path__ + "static/4.3b9c596e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BSc/4.png
// module id = 822
// module chunks = 93830084423213 241891719824365